export function getRichTextFormattingProperties(html) {
  const content = html || '';
  const hasBold = /<(strong|b)[\s>]/i.test(content);
  const hasItalic = /<(em|i)[\s>]/i.test(content);
  const hasUnderline = /<u[\s>]/i.test(content);
  const hasHyperlink = /<a[\s>]/i.test(content);
  const hasBullet = /<ul[\s>]/i.test(content);
  const hasNumbered = /<ol[\s>]/i.test(content);

  let list = 'no';
  if (hasBullet && hasNumbered) {
    list = 'Both';
  } else if (hasNumbered) {
    list = 'Numbered';
  } else if (hasBullet) {
    list = 'Bulleted';
  }

  return {
    Bold: hasBold ? 'yes' : 'no',
    Italic: hasItalic ? 'yes' : 'no',
    Underline: hasUnderline ? 'yes' : 'no',
    Hyperlink: hasHyperlink ? 'yes' : 'no',
    List: list
  };
}
